/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2018 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
  'use strict';

  // Use behaviors with context variable.
  Drupal.behaviors.cookieBanner = {
    attach: function (context) {
      // Have to delay the load to ensure cookie banner is present.
      window.onload = function () {
        // Cookie Banner variables.
        const slidingPop = document.getElementById('sliding-popup');

        if (slidingPop) {
          // Variables
          const manageButton = document.querySelector('.manage-button');
          const preferences = document.getElementById('eu-cookie-compliance-categories');

          manageButton.addEventListener('click', () => {
            // Toggle manage button attribute
            const preferencesExpanded = manageButton.getAttribute('aria-expanded') === 'true' || false;
            manageButton.setAttribute('aria-expanded', !preferencesExpanded);

            // Toggle preferences display
            preferences.hidden = !preferences.hidden;
          });
        }
      };
    }
  };

})(jQuery);
